module.exports = __webpack_public_path__ + "resources/img/img_confluent_platform2_m.e098bac97525442f4371c8f8be3cb770.png";